"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class Timezone {
  static setDefaultTimezone(offset = 0) {
    Timezone.offset = offset;
  }

  static adjustTime(date, currentOffset = null, newOffset = null) {
    const utc = date.getTime() + currentOffset * 3600000;

    if (newOffset !== null && +newOffset != NaN) {
      return new Date(utc + 3600000 * newOffset);
    } else {
      return new Date(utc + 3600000 * Timezone.offset);
    }
  }

}

exports.default = Timezone;

_defineProperty(Timezone, "offset", 0);